import { useTranslation } from "react-i18next";
import fiveStar from "@/assets/five-star.svg";
import TestimonialsScrollSection, {
  TestimonialsCarouselMobile,
} from "./TestimonialsScrollSection";
import { motion } from "framer-motion";
import { landingMotionInView } from "@/utils/landingMotion";

export default function TestimonialSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full overflow-hidden px-4 py-16 text-white sm:px-6 md:pb-20 md:pt-0 lg:px-8">
      <div className="relative mx-auto max-w-7xl">
        <div className="flex flex-col items-stretch gap-10 lg:flex-row lg:gap-6 xl:gap-8">
          {/* Left vertical strip — desktop */}
          <motion.div
            className="hidden min-h-[min(72vh,640px)] w-full shrink-0 lg:block lg:max-w-[300px] lg:min-h-[min(78vh,720px)] xl:max-w-[320px]"
            {...landingMotionInView}
          >
            <TestimonialsScrollSection
              variant="vertical"
              column="left"
              verticalDirection="up"
            />
          </motion.div>

          {/* Center */}
          <motion.div
            className="relative bg-[url('assets/landingpage/testimoniallogo.png')] bg-contain bg-no-repeat bg-center flex min-h-[280px] flex-1 flex-col items-center justify-center lg:min-h-[min(78vh,720px)] "
            {...landingMotionInView}
          >
            {/* Background logo — add your asset here */}
            {/* <img src={testimoniallogo} alt="testimonials background" /> */}
            <div
              className="pointer-events-none absolute left-1/2 top-[42%] z-0 w-[min(100%,420px)] -translate-x-1/2 -translate-y-1/2 select-none opacity-[0.07]"
              aria-hidden
            />

            <motion.div
              className="relative z-[1] mx-auto flex w-full max-w-[640px] flex-col items-center text-center"
              {...landingMotionInView}
            >
              <motion.h2
                className="font-nexa text-[32px] font-normal leading-tight tracking-tight md:text-[52px] lg:text-[56px] md:px-5"
                {...landingMotionInView}
              >
                <span className="text-white">{t("Trusted by Thousands Across")}</span>
                <br className="hidden" />
                <span className="sm:ml-2"> </span>
                <span className="bg-gradient-to-r px-2 from-[#D6E242] via-[#9DDF78] to-[#79DDC7] bg-clip-text italic text-transparent">
                  {t("The Globe")}
                </span>
              </motion.h2>

              <motion.div
                className="mt-8 flex justify-center md:mt-10"
                {...landingMotionInView}
              >
                <div className="rounded-[12px] bg-gradient-to-r from-[#1CCDE6] via-[#9ED473] to-[#DBD633] p-[1px] shadow-[0_0_28px_rgba(157,223,120,0.2)]">
                  <button
                    type="button"
                    onClick={() => {
                      window.open(
                        "https://trustsadvisor.com/businesses/urfx.io",
                        "_blank"
                      );
                    }}
                    className="btn-gradient-left !shadow-none font-nexa w-fit min-w-[160px] rounded-[10px] px-6 py-2.5 text-lg font-bold"

                  >
                    {t("View All Testimonials")}
                  </button>
                </div>
              </motion.div>

              {/* Trust ratings — BlogSection-style glass panel */}
              <motion.div
                className="mt-10 w-full max-w-[540px] md:mt-14"
                {...landingMotionInView}
              >
                <motion.div
                  className="rounded-[22px] border border-white/15 bg-[linear-gradient(180deg,rgba(255,255,255,0.06)_0%,rgba(255,255,255,0.03)_70%,rgba(255,255,255,0.02)_100%)] px-4 py-5 shadow-[0_18px_70px_rgba(0,0,0,0.45)] backdrop-blur-[20px] sm:px-6 sm:py-6"
                  {...landingMotionInView}
                >
                  <div className="flex font-creato items-center justify-between gap-6 flex-row sm:gap-4">
                    <motion.div
                      className="flex w-full flex-col items-center gap-2 sm:w-auto"
                      {...landingMotionInView}
                    >
                      <motion.img
                        src={'/image/testimonial/trust.png'}
                        alt="trust"
                        className="w-[75px] md:w-auto h-8 object-contain md:h-9"
                        {...landingMotionInView}
                      />
                      <motion.div
                        className="flex flex-col items-center gap-2"
                        {...landingMotionInView}
                      >
                        <motion.p
                          className=" text-xs font-semibold text-white"
                          {...landingMotionInView}
                        >
                          4.8/5
                        </motion.p>
                        <motion.img
                          src={fiveStar}
                          alt="five star"
                          className="h-4 md:h-5"
                          {...landingMotionInView}
                        />
                      </motion.div>
                    </motion.div>
                    <motion.div
                      className="hidden h-12 w-px bg-white/10 sm:block"
                      aria-hidden
                      {...landingMotionInView}
                    />
                    <motion.div
                      className="flex w-full flex-col items-center gap-2 sm:w-auto"
                      {...landingMotionInView}
                    >
                      <motion.img
                        src={'/image/testimonial/advisor.png'}
                        alt="advisor "
                        className="w-[75px] md:w-auto h-8 object-contain md:h-9"
                        {...landingMotionInView}
                      />
                      <motion.div
                        className=" flex  flex-col items-center gap-2"
                        {...landingMotionInView}
                      >
                        <motion.p
                          className=" text-xs font-semibold text-white"
                          {...landingMotionInView}
                        >
                          4.7/5
                        </motion.p>
                        <motion.img
                          src={fiveStar}
                          alt="five star"
                          className="h-4 md:h-5"
                          {...landingMotionInView}
                        />
                      </motion.div>
                    </motion.div>
                    <motion.div
                      className="hidden h-12 w-px bg-white/10 sm:block"
                      aria-hidden
                      {...landingMotionInView}
                    />
                    <motion.div
                      className="flex w-full flex-col items-center gap-2 sm:w-auto"
                      {...landingMotionInView}
                    >
                      <motion.img
                        src={'/image/testimonial/proven.png'}
                        alt="proven"
                        className="w-[75px] md:w-auto h-8 object-contain md:h-9"
                        {...landingMotionInView}
                      />
                      <motion.div
                        className="flex  flex-col items-center gap-2"
                        {...landingMotionInView}
                      >
                        <motion.p
                          className=" text-xs font-semibold text-white"
                          {...landingMotionInView}
                        >
                          4.9/5
                        </motion.p>
                        <motion.img
                          src={fiveStar}
                          alt="five star"
                          className="h-4 md:h-5"
                          {...landingMotionInView}
                        />
                      </motion.div>
                    </motion.div>
                  </div>
                </motion.div>
              </motion.div>

              {/* trust review  */}
              <motion.div {...landingMotionInView} className="w-full pt-5">
                <p className="pb-1.5  text-sm md:text-lg font-creato font-medium text-white">Rated <span className="bg-gradient-to-r from-[#1CCDE6] via-[#9ED473] to-[#DBD633] bg-clip-text italic text-transparent">10,000+</span> Traders
                  Excellent
                  by our traders</p>
                  <img src="/image/testimonial/rating.svg" alt="rating logo" width={180} height={26} className="mx-auto w-auto h-auto" />
              </motion.div>
            </motion.div>
          </motion.div>

          {/* Right vertical strip — sktop */}
          <motion.div
            className="hidden min-h-[min(72vh,640px)] w-full shrink-0 lg:block lg:max-w-[300px] lg:min-h-[min(78vh,720px)] xl:max-w-[320px]"
            {...landingMotionInView}
          >
            <TestimonialsScrollSection
              variant="vertical"
              column="right"
              verticalDirection="down"
            />
          </motion.div>
        </div>

        {/* Mobile / tablet: Swiper (BlogSection-style); every slide uses full card-gradient */}
        <motion.div
          className=" -mt-14 lg:mt-0 lg:hidden"
          {...landingMotionInView}
        >
          <TestimonialsCarouselMobile />
        </motion.div>



        {/* small banner */}
        <motion.div {...landingMotionInView} className="w-full mx-auto max-w-[1100px] mt-14 md:mt-10">
          <div className="relative py-4 md:py-5 px-4 md:px-10 w-full flex xl:flex-row gap-y-3 xl:gap-y-0 flex-col justify-between items-center overflow-hidden rounded-[20px] border border-white/50 bg-gradient-to-b from-white/5 to-white/10 !backdrop-blur-sm">
            <p className=" xl:max-w-[232px] text-center xl:text-left  text-xl xl:text-2xl font-creato font-medium text-white">Join <span className="bg-gradient-to-r from-[#1CCDE6] via-[#9ED473] to-[#DBD633] bg-clip-text italic text-transparent">10,000+</span> Traders
              Already Growing
              Their Capital</p>
            <img src="/image/testimonial/bannerbadge.svg" alt="banner badge logo" width={652} height={80} className="w-auto h-auto" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
